<template>
<!--数据用户-->
<div class="userData">
    <div class="content">
        <div class="content-left">
            <div class="content-left-top charts-box">
                <div class="echarts-title">区域用户数量排行</div>
                <echartsScrollBar v-if="hasRankData" :echartsData="userDataRank" id='userScrollBar' width="80%" height="100%" />
            </div>
            <div class="content-left-bottom charts-box">
                <div class="echarts-title">区域用户类型</div>
                <div class="userData-pie">
                    <echartsPie v-if="hasTypeData" :labelData='userTypeData' id='userPie' width="60%" height="calc(40vh - 70px - 45px)" />
                    <div v-if="hasTypeData" class="label">
                        <div class="label-item" v-for="(item,index) in userTypeData" :key="index">
                            <span>{{item.name}}</span>
                            <span class="user_motto">{{item.value}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="AMap-BOX">
            <div class="content-middle-map">
                <echartsMap type="user" :areaId="areaId" @clickMap="mapClick" :markData="userDataRank" width="100%" height="100%"></echartsMap>
            </div>
            <div class="content-middle-line charts-box">
                <div class="echarts-title">新增用户/活跃用户曲线图</div>
                <echartsline type="user" v-if="hasCountInfo" :showMonth="showMonth" :currentIndex="currentIndex" :dateYearNow="dateYearNow" :echartsData="CountInfoData" @DateClick="DateClick" @monthClick="monthClick" id='userLine' width="100%" height="calc(30vh - 70px - 45px)" />
            </div>
        </div>
        <div class="content-right">
            <div class="content-right-top charts-box">
                <div class="echarts-title-right">用户总人数</div>
                <div class="userNum">{{totalCount}}</div>
            </div>
            <div class="content-right-middle charts-box">
                <div class="echarts-title-right">区域用户年龄分布</div>
                <echartsBar type='user' v-if="hasAgeType" :echartsData="ageTypeData" title="" id='alarmBar' width="100%" height="calc(40vh - 70px - 30px)" />
            </div>
            <div class="content-right-bottom charts-box">
                <div class="echarts-title-right">区域用户百分比</div>
                <div class="userData-pie">
                    <div class="label">
                        <div class="label-item" v-for="(item,index) in percentTypeData" :key="index">
                            <span>{{item.name}}</span>
                            <span class="user_motto">{{item.value}}</span>
                        </div>
                    </div>
                    <echartsPie v-if="hasPercent" :labelData='percentTypeData' id='userPieRight' width="60%" height="calc(45vh - 70px - 30px)" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import echartsBar from '../charts-component/bar.vue'
import echartsScrollBar from '../charts-component/barScroll.vue'
import echartsPie from '../charts-component/pie.vue'
import echartsline from '../charts-component/line.vue'
import echartsMap from '../charts-component/map.vue'
import publicFn from '../../../assets/js/publicFn.js'
import {
    cloudApi
} from '../../../api-path/cloud-api.js'
export default {
    name: "dataAlarm",
	props:['clouldAreaCode'],
    components: {
        echartsBar,
        echartsPie,
        echartsScrollBar,
        echartsline,
        echartsMap
    },
    data() {
        return {
            userDataRank: [], //区域用户数量排行
            hasRankData: false,
            userTypeData: [], //区域用户类型
            hasTypeData: false,
            totalCount: 0, //统计总数,
            ageTypeData: [], //区域用户年龄分布
            hasAgeType: false,
            percentTypeData: [], //区域用户百分比
            hasPercent: false,
            CountInfoData: [], //区域新增/活跃用户数据
            hasCountInfo: false,
            dateYearNow: new Date().getFullYear(), //当前年
            currentIndex: 2,
            showMonth: false,
            // areaId
            areaId: ''
        }
    },
	created() {
		this.areaId=this.clouldAreaCode;
	},
    mounted() {
        this.getUserRank()
        this.getUserType()
        this.getAgeType()
        this.getTotalCount()
        this.getPercentType()
        this.getCountInfoHour()
    },
    watch: {
        areaId(newval, oldVal) {
            if (newval) {
                this.hasAgeType = false;
                this.hasPercent = false;
                this.hasRankData = false;
                this.hasTypeData = false;
                this.getUserRank()
                this.getUserType()
                this.getAgeType()
                this.getTotalCount()
                this.getPercentType()
                this.getCountInfoHour()
            }
        },
		clouldAreaCode(newVal,oldVal){
			if(newVal){
				this.areaId=newVal;
			}
		}
    },
    methods: {
        //区域用户数量排行
        getUserRank() {
            this.$http.get(cloudApi.userAreaInfo, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status === 200) {
                    this.hasRankData = true;
                    this.userDataRank = res.result;
                }
            })
        },
        //区域用户类型
        getUserType() {
            this.$http.get(cloudApi.userCountUserByType, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasTypeData = true;
                    this.userTypeData = res.result.map(item => {
                        return {
                            name: item.userTypeName,
                            value: item.num
                        }
                    })
                }
            })
        },
        //用户总数
        getTotalCount() {
            this.$http.get(cloudApi.userTotalCount, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.totalCount = publicFn.formatNum(res.result.toString(), ',', 3);
                }
            })
        },
        //区域用户年龄分布
        getAgeType() {
            this.$http.get(cloudApi.userDistributedAgeCount, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasAgeType = true;
                    this.ageTypeData = res.result.map(item => {
                        return {
                            name: item.ageGroup,
                            num: item.num
                        }
                    })
                }
            })
        },
        //区域用户百分比
        getPercentType() {
            this.$http.get(cloudApi.userPhasePercentCount, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasPercent = true;
                    this.percentTypeData = res.result.map(item => {
                        return {
                            name: item.ageGroup,
                            value: item.num
                        }
                    })
                }
            })
        },
        //用户活跃图
        getCountInfoHour(date) {
            this.$http.get(cloudApi.userCountInfoHour, {
                params: {
                    areaId: this.areaId,
                    date: date ? date : this.dateYearNow
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasCountInfo = true;
                    this.CountInfoData = res.result;
                }
            })
        },
        //切换月日
        monthClick(value) {
            this.hasCountInfo = false;
            this.dateYearNow = value.year;
            this.currentIndex = value.index;
            this.showMonth = value.showMonth;
            this.getCountInfoHour(value.year);
        },
        //切换到天
        DateClick(value) {
            this.hasCountInfo = false;
            this.showMonth = value.showMonth;
            this.getCountInfoHour(value.month);
        },
        //地图点击-切换区域
        mapClick(value) {
            this.areaId = value.adcode;
        },
    }
}
</script>

<style lang="less" scoped>
@import "./../cloud-picture";

.userData-pie {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .label {
        color: #fff;

        .label-item {
            display: flex;
            flex-direction: column;
            background: url(../../../assets/GIS/alert_small.png);
            background-size: 100% 100%;
            width: 6rem;
            height: 3rem;
            justify-content: center;
            align-items: center;
            margin-bottom: 10px;

            span {
                &:nth-child(1) {
                    color: #ddd;
                    font-size: .6rem;
                    margin-bottom: 4px;
                }

                &:nth-child(2) {
                    color: #fff;
                    font-size: 1rem;
                }
            }
        }
    }
}

.userNum {
    font-size: 2rem;
    color: #fff;
    text-align: right;
}
</style>
